module.exports = require("emojione/emoji.json");


//////////////////
// WEBPACK FOOTER
// external "emojione/emoji.json"
// module id = 4
// module chunks = 0